<script lang="ts">
  import CaneHelpersExplanation from "./CaneHelpersExplanation.svelte";
  import OneCaneHelper from "./OneCaneHelper.svelte";

  const types = [
    ['cogs', 'Cogs', 'getCog'],
    ['smooth_cogs', 'Smooth cogs', 'getSmoothCog'],
    ['pinched_circles', 'Pinched circles', 'getPinchedCircle'],
    ['inverted_pinched_circles', 'Inverted pinched circles', 'getInvertedPinched'],
    ['bubbles', 'Bubbles', 'getBubbles'],
    ['scatters', 'Scatter', 'getScatter'],
    ['scatter_pavings', 'Scatter paving', 'getScatterPaving'],
    ['hypotrochoids', 'Hypotrochoids', 'getHypotrochoid'],
  ];

  const largeQty = 2;
  const smallQty = 12;

</script>

<main>
  <table>
    <thead>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Description</th>
        <th scope="col">Random, large</th>
        <th scope="col">Random, small</th>
      </tr>
    </thead>
    <tbody>
      {#each types as [type, name, generatorFctName]}
        <tr>
          <th scope="row">{name}</th>
          <td><CaneHelpersExplanation {type} /></td>
          <td>
            {#each Array(largeQty) as _, index}
              <OneCaneHelper {generatorFctName} size={100} {index} />
            {/each}
          </td>
          <td>
            {#each Array(smallQty) as _, index}
              <OneCaneHelper {generatorFctName} size={40} {index} />
            {/each}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</main>
